import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import { showSnackbar } from "redux/modules/snackbar/actions";
import dashboardApi from "EventLight/Common/Dashboard/api";
import { getCredentials } from "redux/modules/user/selectors";
import { BigFilledButton, BigOutlineButton, Div } from "components/Base";

const RevertOverrideInductionFormModal = ({
  closeModal,
  contactIds,
  showSnackbar,
  userCredentials,
  eventId,
  fetchData,
  contactName = ""
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const {
        success,
        payload
      } = await dashboardApi.revertOverrideInductionForm(userCredentials, {
        contactIds,
        eventId
      });

      if (success) {
        showSnackbar({
          message:
            payload.message || "Induction form override reverted successfully",
          variant: "success"
        });
        fetchData();
        closeModal();
      } else {
        showSnackbar({
          message:
            payload.message || "Failed to revert induction form override",
          variant: "error"
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      showSnackbar({
        message: error.message || "Failed to revert induction form override",
        variant: "error"
      });
      setIsSubmitting(false);
    }
  };

  return (
    <StyleWrapper
      heading="Revert Override"
      hideModal={closeModal}
      width={500}
      bodyStyles={{ padding: 20 }}
      containerStyles={{ padding: 0 }}
      data-cy="revert-override-induction-form-modal"
    >
      <Div fs={3}>
        Are you sure you want to revert the induction form override
        {contactName ? ` for ` : ""}
        {contactName && <strong>{contactName}</strong>}?
        <Div fs={2} color="gray7" pt={2} pb={5}>
          <strong>Note:</strong> This will restore the form to its previous
          status and may require the contact to complete the form.
        </Div>
      </Div>
      <div style={{ display: "flex", gap: 10 }}>
        <BigOutlineButton width={1} onClick={closeModal}>
          Cancel
        </BigOutlineButton>
        <BigFilledButton
          bg="altB5"
          width={1}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Reverting..." : "Revert Override"}
        </BigFilledButton>
      </div>
    </StyleWrapper>
  );
};

RevertOverrideInductionFormModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  contactIds: PropTypes.array.isRequired,
  showSnackbar: PropTypes.func.isRequired,
  userCredentials: PropTypes.object.isRequired,
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchData: PropTypes.func.isRequired,
  contactName: PropTypes.string
};

export default connect(
  state => ({
    userCredentials: getCredentials(state)
  }),
  { showSnackbar }
)(RevertOverrideInductionFormModal);
